import { DeviceEnabledType, UserAttributeDefs } from '@iotv/datamodel-core';
import { Position } from '@iotv/iotv-v3-types';

const typeName = 'FlowMeter';

export type WaterFlowProps = {
  purposeType?: string;
  meterType?: string;
  diameter?: number;
  maximumFlowRate?: number;
  setFlowRate?: number;
  flow?: number;
  location?: Position;
  pulseCounterFrequency?: number;
  pulseCountCalibration?: number;
  image?: string;
  flowperpulse?: number;
};

export class FlowMeter extends DeviceEnabledType {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  purposeType?: string;
  meterType?: string;
  diameter?: number;
  maximumFlowRate?: number;
  setFlowRate?: number;
  flow?: number;
  location?: Position;
  pulseCounterFrequency?: number;
  pulseCountCalibration?: number;
  image?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of Water Flow Meter',
      },
      purposeType: {
        type: 'String',
        editable: true,
        label: 'Purpose/ Type',
        name: 'purpose/Type',
        description: 'Purpose/ type of Flow',
      },
      meterType: {
        type: 'String',
        editable: true,
        label: 'Meter Type',
        name: 'meterType',
        description: 'Meter type',
      },
      diameter: {
        type: 'Number',
        editable: true,
        label: 'Diameter',
        name: 'diameter',
        description: 'Diameter of Water Flow pipe - mm',
      },
      maximumFlowRate: {
        type: 'Number',
        editable: true,
        label: 'Maximum Flow Rate',
        name: 'maximumFlowRate',
        description: 'Maximum flow rate ',
      },
      // setFlowRate: {
      //   type: "Number",
      //   editable: true,
      //   label: "Set Flow Rate",
      //   name: "setFlowRate",
      //   description: "Flow rate set for the Water Flow",
      // },
      // flow: {
      //   type: "Number",
      //   editable: true,
      //   label: "Flow",
      //   name: "flow",
      //   description: "Water flow  litres/ sec and cubic metres/ sec",
      // },
      location: {
        type: 'object',
        editable: true,
        label: 'Location',
        name: 'location',
        description: 'Location of  Water Flow Meter (lat/ long)',
      },
      // pulseCounterFrequency: {
      //   type: "Number",
      //   editable: true,
      //   label: "Pulse counter frequency",
      //   name: "pulseCounterFrequency",
      //   description: "Frequency of pulse counts from meter to measure flow",
      // },
      pulseFlowAmount: {
        type: 'Number',
        editable: true,
        label: 'Flow per pulse',
        name: 'pulseFlowAmount',
        description: 'Flow per pulse to calculate water flow',
      },
      // pulseCountCalibration: {
      //   type: "Number",
      //   editable: true,
      //   label: "Pulse Count Calibration",
      //   name: "pulseCountCalibration",
      //   description: "Calibration of pulse counts to calculate water flow",
      // },
      image: {
        type: 'String',
        editable: true,
        label: 'Image',
        name: 'image',
        description: 'Photograph of Water Flow meter',
      },
      comments: {
        type: 'String',
        editable: true,
        label: 'Comments',
        name: 'comments',
        description: 'Free text for info ',
      },
    };
  }
}
